// @flow
import React from 'react';
import ReactFloater from 'react-floater';
import Text from './Typography';

export const FloaterStyles = {
  arrow: {
    color: '#EBEEFB'
  },
  floater: {
    filter: 'none',
    padding: '0'
  }
};

type State = {
  open: boolean
}

type Props = {
  className: string,
  id: string,
  type: string,
  children: any,
  header: string,
  text: string,
  noUnderline?: boolean,
  placement: string // top, bottom, left, right, right-end,
  // right-start, left-end, left-start, auto
}

class Floater extends React.Component {
  state: State = {
    open: false
  };

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  handleClickOutside = (event: Object) => {
    if (event.target && event.target.className !== 'floater') {
      this.setState({
        open: false
      });
    }
  }

  toggle = () => {
    this.setState({
      open: !this.state.open
    });
  }

  props: Props;

  render() {
    const { children, text, placement, noUnderline } = this.props;
    const { open } = this.state;

    const floatContent = (
      <div className='floater floater__tooltip'>
        <Text paragraph>{text}</Text>
      </div>);

    return (
      <ReactFloater
        component={floatContent}
        styles={FloaterStyles}
        open={open}
        offset={0}
        placement={placement || 'top'}
      >
        <div
          role='button'
          tabIndex={0}
          className={`floater__target ${open ? 'is-active' : ''}`}
          onClick={this.toggle}
        >
          <div className={`${noUnderline ? '' : 'floater__underlined-text'}
            ${open ? 'is-active' : ''}`}
          >
            {children}
          </div>
        </div>
      </ReactFloater>
    );
  }
}

export default Floater;



// WEBPACK FOOTER //
// ./src/components/shared/Floater.js